var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0-5.52-4.48-10-10-10S0 4.48 0 10s4.48 10 10 10 10-4.48 10-10zM1.395 10c0-4.749 3.856-8.605 8.605-8.605 4.749 0 8.605 3.856 8.605 8.605 0 4.749-3.856 8.605-8.605 8.605-4.749 0-8.605-3.856-8.605-8.605z",
    fill: "#EC6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19 13.702a.697.697 0 11-.986-.986l6.512-6.512a.697.697 0 11.986.986L7.19 13.702z",
    fill: "#EC6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.702 12.716a.697.697 0 11-.986.986L6.204 7.19a.697.697 0 11.986-.986l6.512 6.512z",
    fill: "#EC6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.ce0dbca7a841f26627860e7f47915270.svg";
export { ForwardRef as ReactComponent };